import constants from '../../constants'
import { getChatApiBase, getChatApiHeaders } from '../chatApiClient'
import axios from '../axiosInstance'

export async function list(app: any, apiHost: string, pageNo = 1, searchText = '') {
  const URL = `${getChatApiBase(app, apiHost)}/roles?per_page=${
    constants.perPageInListings
  }&useCursoredIndex=1`
  return axios
    .get(`${URL}`, {
      headers: getChatApiHeaders(app),
      params: { page: pageNo, searchKey: searchText, _: Date.now() },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error?.response?.data ?? Promise.reject(error)
    })
}

export async function get(id: string, app: any, apiHost: string) {
  const URL = `${getChatApiBase(app, apiHost)}/roles/${id}`
  return axios
    .get(`${URL}`, {
      headers: getChatApiHeaders(app),
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error?.response?.data ?? Promise.reject(error)
    })
}

export async function add(post: any, app: any, apiHost: string) {
  const URL = `${getChatApiBase(app, apiHost)}/roles`
  return axios
    .post(`${URL}`, post, {
      headers: getChatApiHeaders(app),
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error?.response?.data ?? Promise.reject(error)
    })
}

export async function search(app: any, apiHost: string, searchText: string, pageNo = 1) {
  const URL = `${getChatApiBase(app, apiHost)}/roles?per_page=${
    constants.perPageInListings
  }&useCursoredIndex=1`
  return axios
    .get(`${URL}`, {
      headers: getChatApiHeaders(app),
      params: { page: pageNo, searchKey: searchText },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error?.response?.data ?? Promise.reject(error)
    })
}

export async function del(id: string, app: any, apiHost: string) {
  const URL = `${getChatApiBase(app, apiHost)}/roles/${id}`
  return axios
    .delete(`${URL}`, {
      headers: getChatApiHeaders(app),
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error?.response?.data ?? Promise.reject(error)
    })
}

export async function update(id: string, post: any, app: any, apiHost: string) {
  const URL = `${getChatApiBase(app, apiHost)}/roles/${id}`
  return axios
    .put(`${URL}`, post, {
      headers: getChatApiHeaders(app),
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error?.response?.data ?? Promise.reject(error)
    })
}
